/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, price: NonNullable<unknown>, period: NonNullable<unknown> }} Confirmupgradedescription2Inputs */

const en_confirmupgradedescription2 = /** @type {(inputs: Confirmupgradedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are upgrading to the ${i?.tier} plan for ${i?.price} ${i?.period}. The upgrade will be available immediately after confirmation.`)
};

const de_confirmupgradedescription2 = /** @type {(inputs: Confirmupgradedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du wechselst zum ${i?.tier}-Plan für ${i?.price} ${i?.period}. Der neue Plan gilt sofort nach der Bestätigung.`)
};

/**
* | output |
* | --- |
* | "You are upgrading to the {tier} plan for {price} {period}. The upgrade will be available immediately after confirmation." |
*
* @param {Confirmupgradedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmupgradedescription2 = /** @type {((inputs: Confirmupgradedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmupgradedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmupgradedescription2(inputs)
	return de_confirmupgradedescription2(inputs)
});
export { confirmupgradedescription2 as "confirmUpgradeDescription" }